export const _surveyClass = {
  name: { type: 'string', title: 'Kyselyn nimi' },
  description: { type: 'string', title: 'Kuvaus' },
  anonymous: {
    type: 'boolean',
    title: 'Anonyymi kysely',
    description: 'Piilotetaan vastaajan tiedot tuloksista'
  },
  showOnUserUI: {
    type: 'boolean',
    title: 'Näytä asiakaskäyttöliittymässä',
    description: 'Jos ei valittu, kysely on saatavilla vain suoran linkin kautta'
  },
  startDate: {
    type: 'string',
    format: 'date',
    title: 'Aloituspäivä',
    description: 'Valinnainen aloituspäivä kyselylle'
  },
  deadline: {
    type: 'string',
    format: 'date',
    title: 'Määräaika',
    description: 'Valinnainen päättymispäivä kyselylle'
  },
}

export const _surveyUISchema = {
  description: {
    'ui:widget': 'textarea',
    'ui:options': {
      rows: 3
    }
  },
}

export const _surveyQuestionTypes = [
  { value: 'text', label: 'Teksti' },
  { value: 'textarea', label: 'Tekstialue' },
  { value: 'number', label: 'Numero' },
  { value: 'email', label: 'Sähköposti' },
  { value: 'phone', label: 'Puhelin' },
  { value: 'date', label: 'Päivämäärä' },
  { value: 'select', label: 'Valinta' },
  { value: 'multiselect', label: 'Monivalinta' },
  { value: 'radio', label: 'Radio' },
  { value: 'checkbox', label: 'Valintaruutu' },
  { value: 'rating', label: 'Arvio (1-5)' },
  { value: 'nps', label: 'NPS (0-10)' },
  { value: 'paragraph', label: 'Ohjeteksti' },
]

export const SURVEY_STATE_TRANSLATIONS = {
  draft: 'Luonnos',
  scheduled: 'Ajastettu',
  active: 'Aktiivinen',
  closed: 'Suljettu',
  deleted: 'Poistettu',
}

export const SURVEY_STATE_COLORS = {
  draft: 'secondary',
  scheduled: 'info',
  active: 'success',
  closed: 'warning',
  deleted: 'danger',
}
